import {$getRoot, $isElementNode, LexicalNode, NodeKey} from 'lexical';

export interface EditorNodeRange {
  node: LexicalNode;
  start: number;
  end: number;
}

// ElementNode.getTextContent joins block children with a double line break.
const BLOCK_SEPARATOR_LENGTH = 2;

export function $collectEditorNodeRanges() {
  const rangeByKey = new Map<NodeKey, EditorNodeRange>();
  const leaves: EditorNodeRange[] = [];

  const visit = (node: LexicalNode, start: number): number => {
    if (!$isElementNode(node)) {
      const range = {node, start, end: start + node.getTextContentSize()};
      rangeByKey.set(node.getKey(), range);
      leaves.push(range);
      return range.end;
    }

    const children = node.getChildren();
    let offset = start;

    children.forEach((child, index) => {
      offset = visit(child, offset);
      if ($isElementNode(child) && !child.isInline() && index !== children.length - 1) {
        offset += BLOCK_SEPARATOR_LENGTH;
      }
    });

    rangeByKey.set(node.getKey(), {node, start, end: offset});
    return offset;
  };

  visit($getRoot(), 0);

  return {rangeByKey, leaves};
}
